<div [hidden]="screen !== FeePaymentScreens.INIT">
    <div class="modal-body">
        <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
        <cm-payment-form
            #paymentForm
            [paymentAmount]="paymentAmount"
            [step]="step"
            [endpointUrl]="endpointUrl"
            [place]="PAYMENT_FORM_PLACE.FEE_STEP"
            [additionalPaymentParameters]="additionalPaymentParameters"
            (initFailed)="back.emit()"
        ></cm-payment-form>
    </div>
    <div class="modal-footer footer-container">
        <button type="button" class="btn btn-default" (click)="back.emit()">BACK</button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
        <button type="button" class="btn btn-primary" (click)="onPay()">
            PAY {{ currencyIcon }}{{ paymentAmount | cmCurrency }}
        </button>
    </div>
</div>

<div [hidden]="screen !== FeePaymentScreens.CONFIRM">
    <div class="modal-body">
        <p class="details-description payment-confirm-header">Would you like to make a payment?</p>
        <cm-confirm-info [fileInfoReqired]="false" [info]="paymentConfirmationInfo"></cm-confirm-info>
    </div>
    <div class="modal-footer footer-container">
        <button type="button" class="btn btn-default" (click)="declineConfirmation()">BACK</button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">CONFIRM</button>
    </div>
</div>

<div [hidden]="screen !== FeePaymentScreens.ATTENTION">
    <div class="modal-body">
        <p class="details-description payment-confirm-header">Attention</p>
        <cm-display-html
            class="attention-text"
            content="You will now be re-directed to a secure, third-party payment page to enter your payment information. Once the transaction is complete, you will be re-directed back to your account on the Certemy platform."
        ></cm-display-html>
    </div>
    <div class="modal-footer footer-container">
        <button type="button" class="btn btn-default" (click)="attentionBack()">BACK</button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
        <button type="button" class="btn btn-primary" (click)="attentionProceed()">PROCEED</button>
    </div>
</div>
